interface flashMessageOption {
    message_type: string;
    message: string;
    autohide: boolean|number
}
const flashMessageNotify = (option: flashMessageOption) => {
    const {
        message_type, // alert | success | error | warning | info
        message, // "Notify.js Demo. Super simple Notify plugin."
        autohide, // true | false
    } = option;

    let _element;
    const _container = document.body;
    const _create = () => {
        _element = document.createElement('div');
        _element.classList.add('flash-message-modal', '--' + message_type.toLowerCase().trim());
        _element.style.right = '10px';
        _element.style.bottom = '10px';

        if (autohide === true) {
            _element.dataset.autohide = 'true';
        } else if (autohide !== false) {
            _element.dataset.autohide = autohide;
        }

        const _closeButton = document.createElement('div');
        _closeButton.classList.add('flash-message-close-btn');
        _element.appendChild(_closeButton);

        const _message = document.createElement('div');
        _message.classList.add('flash-message-text');
        _message.textContent = message;
        _element.appendChild(_message);
        _container.appendChild(_element);

    }

    _create();
    flashMessageShow();

    return true;
}
const flashMessageShow = () => {

    const flashMessages = document.querySelectorAll(".flash-message-modal");
    const isFlashMessages = () => flashMessages.length;

    const _position = {
        x: 'right',
        y: 'bottom',
    };

    const _hide = (flashMessage: Element) => {
        // close modal
        (flashMessage as HTMLElement).style.setProperty("transition", "transform 0.5s, opacity 0.5s");
        (flashMessage as HTMLElement).style.setProperty("transform", 'translateY(-100%)');
        (flashMessage as HTMLElement).style.setProperty("opacity", '0');
        setTimeout(() => {
            flashMessage.remove();
            _checkPosition();
        }, 500);


        // setTimeout(() => {
        //   document.body.removeChild(flashMessage);
        //   // check position
        //   // let currentPosition = 0;
        //   //
        //   // flashMessages.forEach((e, i) => {
        //   //   const elementHeight = e.offsetHeight;
        //   //   const marginTop = parseInt(getComputedStyle(e).marginTop);
        //   //   const marginBottom = parseInt(getComputedStyle(e).marginBottom);
        //   //   e.style['bottom'] = `${currentPosition}px`;
        //   //   currentPosition += elementHeight + marginTop + marginBottom;
        //   // });
        // }, 500);
    }

    const _checkPosition = () => {
        let currentPosition = 0;
        const flashMessages = document.querySelectorAll(".flash-message-modal");
        flashMessages.forEach((flashMessage: Element) => {
            const elementHeight = (flashMessage as HTMLElement).offsetHeight;
            const marginTop = parseInt(getComputedStyle((flashMessage as HTMLElement)).marginTop);
            const marginBottom = parseInt(getComputedStyle((flashMessage as HTMLElement)).marginBottom);
            (flashMessage as HTMLElement).style[_position.y] = `${currentPosition}px`;
            currentPosition += elementHeight + marginTop + marginBottom;
        })

    }


    if (isFlashMessages) {
        flashMessages.forEach((flashMessage: Element) => {
            // (flashMessage as HTMLElement).style.setProperty("bottom", `${currentPosition}px`);

            (flashMessage as HTMLElement).style.transform = 'translateY(-100%)';
            (flashMessage as HTMLElement).style.opacity = '0';
            (flashMessage as HTMLElement).style.marginRight = '10px';
            (flashMessage as HTMLElement).style.marginBottom = '10px';

            setTimeout(() => {
                (flashMessage as HTMLElement).style.transition = 'transform 0.5s, opacity 0.5s';
                (flashMessage as HTMLElement).style.transform = 'translateY(0)';
                (flashMessage as HTMLElement).style.opacity = '1';

                _checkPosition()

            }, 100);


            const closeButton = flashMessage.querySelector('.flash-message-close-btn')
            closeButton.addEventListener("click", (event) => {
                event.preventDefault();
                _hide(flashMessage)
            });


            let autohide: boolean|number = false;
            let autohide_timeout = 2500;

            if (flashMessage.hasAttribute('data-autohide')) {
                const datasetAutohide = flashMessage.getAttribute('data-autohide');

                if (datasetAutohide === '') {
                    autohide = false;
                } else if (datasetAutohide === 'true') {
                    autohide = true;
                } else if (datasetAutohide !== 'false') {
                    autohide = true;
                    autohide_timeout = parseInt(datasetAutohide);
                }
            }

            if (autohide) {
                setTimeout(() => {
                    _hide(flashMessage)
                }, autohide_timeout);
            }

        })
    }
}

flashMessageShow();

window["flashMessageNotify"] = flashMessageNotify
